import React, { useCallback, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  TextField,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  Button,
  InputAdornment,
} from "@mui/material";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import InfoIcon from '@mui/icons-material/Info';
import AccountCreated from "../../Assets/img/Account-Created.png";
import FormControl from '@mui/joy/FormControl';
import FormHelperText from '@mui/joy/FormHelperText';
import RadioGroup from '@mui/joy/RadioGroup';
import Radio from '@mui/joy/Radio';
import Sheet from '@mui/joy/Sheet';
// import EmailVerified from "../../Assets/img/Email-Verified.png";
import axios from 'axios';
import PasswordGen from "./PasswordGen";
import Tick from '../../Assets/img/Shape.svg'
import Warningimage from '../../Assets/img/Group 1000002701.svg'
import InfoToast from "../Utilities/InfoToast";
import { useDispatch } from "react-redux";
import { postOnboardingCreateCardReducer, postOnboardingCreateProfessionalCardReducer, postOnboardingCreateStudentCardReducer, postOnboardingReducer } from "../../Redux/Reducers/OnboardingReducer";
import { useSelector } from "react-redux";
import { getAllCardDetailsReducer, getAllCardInfoReducer } from "../../Redux/Reducers/CardReducer";
import { useQuantityContext } from "../QuantityContext";
import { getEducationReducer, getExperienceReducer, getProfessionalInfoReducer, postProfessionalProfileReducer } from "../../Redux/Reducers/ProfileReducer";
import { userOnboardByCreateLinkReducer } from "../../Redux/Reducers/EnterpriseReducer";

const ActiveStep5 = ({ formData, setFormData, setActiveStep, education, experience, activeStep, isSignup }) => {
  const apiKey = process.env.REACT_APP_API_KEY
  const headers = {
    'x-api-key': apiKey,
    'Content-Type': 'application/json',
    // "ngrok-skip-browser-warning": "69420"
  };
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const onboardingToken = useSelector((state) => state?.onboarding?.onboardingData?.data?.accessToken);

  // console.log("Onboarding VALUESS", formData);

  const { handleInfo } = useQuantityContext();
  // console.log("ACCESS TOKEN IN THE ", onboardingToken);
  const [password, setPassword] = useState("");
  const [CreatepasswordPage, setCreatepasswordPage] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState("");
  const [ShowPasswordError, setShowPasswordError] = useState(false);
  const [passwordVerified, setpasswordVerified] = useState(false);
  const [isVerifiedDialogOpen, setIsVerifiedDialogOpen] = useState(true);
  const [errorMessage, seterrorMessage] = useState("Enter Valid Password");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [TwoFactorAuthFirstPage, setTwoFactorAuthFirstPage] = useState(false);
  const [TwoFactorAuthSecondPage, setTwoFactorAuthSecondPage] = useState(false)
  const [selectedOption, setSelectedOption] = useState(null);
  const [showCode, setShowCode] = useState(false);
  const [code, setCode] = useState('');
  const [showCodeError, setShowCodeError] = useState(false);
  const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/;
  const [isTextFieldSelected, setIsTextFieldSelected] = useState(false);
  const [isCorrectOTP, setIsCorrectOTP] = useState(false);
  const [loading, setLoading] = useState(false);
  // console.log("LoadingLoading", loading)
  const [isPasswordSet, setIsPasswordSet] = useState(false);

  const isButtonDisabled = password.trim() === "" || confirmPassword.trim() === "" // || password !== confirmPassword || ShowPasswordError || !passwordRegex.test(password) || !passwordRegex.test(confirmPassword); //Condition for Password

  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const timeout = setTimeout(() => {
      setIsVisible(false);
    }, 30000);

    // Clear the timeout when the component unmounts
    return () => clearTimeout(timeout);
  }, []);

  const togglePasswordVisibility = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };

  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(
      (prevShowConfirmPassword) => !prevShowConfirmPassword
    );
  };

  const handleCloseVerifiedDialog = () => {
    setIsVerifiedDialogOpen(false);
    // setVerificationPageVisible(false);
    //? setShowProfessionalContent(true); Show professional content after closing the dialog
  };

  const handleCreatepassword = async () => {
    // setCreatepassword(true);
    setIsVerifiedDialogOpen(false)
    // setActiveStep(4); // Jump directly to the optional resume upload step
    // window.location.reload();
    if (isSignup) {
      setActiveStep(4)
    }
    else {
      if (typeof setActiveStep === 'function') {
        setActiveStep();
      }
    }
    // setTwoFactorAuthFirstPage(true);
    // setpasswordVerified(false);
    // window.history.replaceState(null, "", `${process.env.REACT_APP_CARD_URL}/cards`);
    // window.location.href = "/cards";

  };

  const handlePasswordChange = (e) => {
    setShowPasswordError(false);
    setPassword(e.target.value);
  };

  const handleConfirmPasswordChange = (e) => {
    setConfirmPassword(e.target.value);
    setShowPasswordError(false);
  };

  const handlePasswordGen = () => {
    const generatedPassword = PasswordGen();
    setPassword(generatedPassword);
    setConfirmPassword(generatedPassword);
  }

  const handleVerifyPassword = async (e) => {
    // setLoading(true);
    if (!passwordRegex.test(password)) {
      setShowPasswordError(true);
      seterrorMessage(
        "Password must contain Uppercase, lowercase and have atleast 8 characters"
      );
      return;
    } else if (
      password !== confirmPassword ||
      password.trim() === "" ||
      confirmPassword.trim() === ""
    ) {
      setShowPasswordError(true);
      seterrorMessage("Enter Valid Password");
    }
    else {
      // console.log("THis is before the Password");
      setpasswordVerified(true);
      // console.log("THis is after the Password");
      setFormData((prevFormData) => ({
        ...prevFormData,
        password: password,
      }));
      await performOnboarding();
      // setIsPasswordSet(true);
    }

  };

  // useEffect(() => {
  //   if (isPasswordSet && formData.password) {
  //     performOnboarding();
  //     setIsPasswordSet(false); // Reset flag
  //   }
  // }, [formData.password, isPasswordSet]);

  // console.log("Onboardiong data", formData);


  const submitOnboarding = async (formData) => {
    setLoading(true);
    handleInfo("Please wait to complete the Process.")
    try {
      const response = await dispatch(postOnboardingReducer(formData))
      console.log("responseresponse", response)
      if (!response) {
        throw new Error("Onboarding failed. Please retry.");
      }
      const userRefId = response.payload.data.user_ref_id;

      // await handleEnterpriseDetails(userRefId)
      // const data = await response.json();
      // console.log("User created:", data);

      return response?.payload?.data?.accessToken; // Assuming `userId` is returned from the server
    } catch (error) {
      console.error("Error submitting onboarding:", error);
      throw error; // Propagate the error for further handling if needed
    } finally {
      setLoading(false);
    }
  };
  console.log("Formdata Formdata Formdata", formData);

  // const handleEnterpriseDetails = (userRefId) => {
  //   const organizationId = localStorage.getItem('organizationId');
  //   const id = localStorage.getItem('entityId');
  //   const userType = localStorage.getItem('userType');
  //   const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  //   // const userRefId = userDetails?.reference_id;

  //   console.log("organizationId", organizationId, "id", id, "userType", userType, "userDetails", userDetails, "userRefId", userRefId);
  //   if (organizationId && id && userType) {
  //     dispatch(userOnboardByCreateLinkReducer({
  //       organizationId: Number(organizationId),
  //       userRefId: userRefId,
  //       userType: userType,
  //       id: Number(id)
  //     }));

  //     // Clear after use
  //     localStorage.removeItem('organizationId');
  //     localStorage.removeItem('entityId');
  //     localStorage.removeItem('userType');
  //   }
  // };

  const callAdditionalAPI1 = async (newCardDetails) => {
    // console.log("mysql result ", newCardDetails);
    const storedObjectId = localStorage.getItem('objectId');


    try {

      if (formData?.profession === "Professional") {
        const cardresponse = await CreateProfessionalCard();

        console.log(" CreateProfessionalCard COMPLETED");
        console.log("responseresponse", cardresponse);

        const updatedDetails = {
          company_name: experience?.companyName,
          website: experience?.website,
          designation: experience?.Role,
          start_year: experience?.startyear,
          is_currently_working: experience?.iscurrentlyworking ?? true,
          professional_email: experience?.emailId,
        }

        const response = await dispatch(postProfessionalProfileReducer(updatedDetails));
        if (response?.payload?.statusCode === 200) {

          // await dispatch(getProfessionalInfoReducer());
          const updatedData = await dispatch(getProfessionalInfoReducer());
        }
      }

      if (formData?.profession === "Student") {
        const cardresponse = await CreateStudentCard();

        console.log(" CreateProfessionalCard COMPLETED");
        console.log("responseresponse", cardresponse);
      }

      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/card/createcardonboard`,
        newCardDetails,
        {
          headers: {
            'x-api-key': apiKey,
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${storedObjectId}`,
            // "ngrok-skip-browser-warning": "69420"
          }
        }
      );

      // console.log("responseresponse", response);
      // console.log('Success');
      await dispatch(getAllCardDetailsReducer());
      await dispatch(getAllCardInfoReducer());
      await dispatch(getExperienceReducer());
      await dispatch(getEducationReducer());

    }
    catch (error) {
      console.error('Error submitting card details:', error);
    }
  };

  const CreateProfessionalCard = async () => {
    // console.log("CreateProfessionalCard was called");

    try {
      const CardformData = new FormData();
      CardformData.append("company_name", experience?.companyName || "");
      CardformData.append("company_domain", experience?.website || "")
      CardformData.append("company_email", experience?.emailId);
      CardformData.append("is_verified", Boolean(experience?.is_verified));
      CardformData.append("location", "");
      CardformData.append("location_type", "");
      CardformData.append("role_title", experience?.Role || "")
      CardformData.append("employee_type", "")
      CardformData.append("details", "")
      CardformData.append("start_month", experience?.startmonth);
      CardformData.append("end_month", "");
      CardformData.append("start_year", experience?.startyear);
      CardformData.append("logo_url", experience?.logo);
      CardformData.append("end_year", "");
      CardformData.append("is_currently_working", experience?.iscurrentlyworking ?? true);
      CardformData.append("responsibility", []);
      CardformData.append("profile_headline", "");
      CardformData.append("is_public", true);
      // CardformData.append("logo_file", "");


      const Professionalresponse = await dispatch(postOnboardingCreateProfessionalCardReducer(CardformData));
      console.log("Professionalresponse", Professionalresponse);
    } catch (error) {
      console.log("API ERROR", error);
    }

  };

  const CreateStudentCard = async () => {
    try {
      const StudentformData = new FormData();
      StudentformData.append("institute_domain", education?.institute_domain);
      StudentformData.append("educational_level", education?.eduLevel || "");
      StudentformData.append("board", "");
      StudentformData.append("field_of_study", "");
      StudentformData.append("institute_name", education?.institute || "");
      StudentformData.append("degree", "");
      StudentformData.append("percentage", "");
      StudentformData.append("start_year", education?.startyear);
      StudentformData.append("logo_url", education?.logo);
      // StudentformData.append("end_year", education?.endyear=== "Present" ? new Date().getFullYear() :education?.endyear);

      StudentformData.append(
        "end_year",
        education?.iscurrentlypurusing ? new Date().getFullYear() : education?.endyear
      );

      StudentformData.append("is_pursuing", education?.isCurrentlyPursuing ?? false);
      StudentformData.append("desc", "");
      StudentformData.append("is_public", true);
      StudentformData.append("is_verified", false);


      const studentresponse = await dispatch(postOnboardingCreateStudentCardReducer(StudentformData));
      console.log("response", studentresponse);
    } catch (error) {
      console.log("API ERROR", error);
    }

  }

  const performOnboarding = async () => {
    // console.log("I am hewref as well")
    setLoading(false)
    // if (!passwordVerified) return;

    try {

      const formDataa = new FormData();

      formDataa.append('firstName', formData?.firstName);
      formDataa.append('lastName', formData?.lastName);
      formDataa.append('dob', formData?.dob);
      formDataa.append('timeOfBirth', formData?.timeOfBirth || '')
      formDataa.append('profession', formData?.profession);
      formDataa.append('personalEmail', JSON.stringify(formData?.personalEmail));
      formDataa.append('professionalEmail', JSON.stringify(formData?.professionalEmail));
      formDataa.append('phoneNo', formData?.phoneNo);
      formDataa.append('password', password);

      // Append image only if it's selected
      if (formData?.image?.data) {
        const response = await fetch(formData.image.data); // Fetch blob
        const blob = await response.blob(); // Convert response to Blob

        // Append image as a file
        formDataa.append('profile_pic', blob, formData.image.name);
      }

      // for (let [key, value] of formDataa.entries()) {
      //   console.log("IAMFORMDATAAAA", key, value);
      // }
      const objectId = await submitOnboarding(formDataa);
      localStorage.clear();
      // console.log("Object ID:" + objectId);

      localStorage.setItem('objectId', objectId);
      // Call the userDetails API to set the details in localStorage
      const userResponse = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/v1/mail/user`, {
        headers: {
          ...headers,
          'Authorization': `Bearer ${objectId}`
        }
      });
      const userData = userResponse.data?.data?.user;
      localStorage.setItem("userDetails", JSON.stringify(userData));
      setCreatepasswordPage(true);

      const newCardDetails = {
        User_ID: objectId,
        profile_pic: userData?.profile_url || null,
        CardType: formData.profession,
        card_mobile: formData.phoneNo,
        card_email: formData.personalEmail.email,
        created_by: formData.firstName + formData.lastName
      };

      await callAdditionalAPI1(newCardDetails);


    } catch (error) {
      console.error("Error during onboarding process", error);
      setpasswordVerified(false);// reset the verification state in case of error
    } finally {
      setLoading(false)
    }

  };


  const [anchorEl, setAnchorEl] = React.useState(null);

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  /* Two Factor Authentication part */

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
  };

  const handleContinue2 = () => {
    setIsVerifiedDialogOpen(false);

  };

  const handleCodeChange = (event) => {
    setValidVerify2FA(false);
    setCode(event.target.value);
    setShowCodeError(false); // Clear code error message
    setShowErrorMessage(false); // Clear OTP error message
  };

  const toggleCodeVisibility = () => {
    setShowCode(prev => !prev);
  };

  const [showErrorMessage, setShowErrorMessage] = useState(false);

  // Modify handleCodeSubmit to display error message for incorrect OTP entry
  const handleCodeSubmit = () => {
    setValidVerify2FA(true);
    if (code.trim() === "") {
      setShowCodeError(true);
      return;
    }

    if (minutes === 0 && seconds === 0) {
      setIsVerificationFailedDialogOpen(true);
      setShowErrorMessage(false);
      return;
    }

    if (selectedOption === "email") {
      console.log("formdata after mysql onboard", formData);
      axios
        .post(`${process.env.REACT_APP_BACKEND_URL}/onboard/twofactor-verify-otp`, {
          email: `${formData.personalEmail.email}`,
          otp: parseInt(code),
        },
          {

            headers: headers

          }
        )
        .then((response) => {
          // console.log("OTP verified successfully");
          setIsVerifiedDialogOpen(true);
          setIsCorrectOTP(true);
          setShowErrorMessage(false); // Reset error message on successful verification
        })
        .catch((error) => {
          setIsVerificationFailedDialogOpen(true);
          console.error("Failed to verify OTP:", error);
          setShowErrorMessage(true);
          setIsCorrectOTP(false);
        });
    } else {
      axios.post(`${process.env.REACT_APP_BACKEND_URL}/onboard/twofactorverify-mobile-otp`, {
        mobileNumber: `${formData.phoneNo}`,
        otp: parseInt(code),
      },
        {
          headers: headers
        })
        .then((response) => {
          // console.log("Mobile OTP verified successfully");
          setIsVerifiedDialogOpen(true);
          setIsCorrectOTP(true);
          setShowErrorMessage(false); // Reset error message on successful verification
        })
        .catch((error) => {
          setIsVerificationFailedDialogOpen(true);
          console.error("Failed to verify mobile OTP:", error);
          setShowErrorMessage(true);
          setIsCorrectOTP(false);
        });
    }
  };
  const [ValidNext2FA, setValidNext2FA] = useState(false);
  const [ValidVerify2FA, setValidVerify2FA] = useState(false);

  const handleAuthNextPage = () => {
    setIsVerifiedDialogOpen(false);
    setValidNext2FA(true);
    setIsVisible(true);
    if (selectedOption === "email") {
      axios.post(`${process.env.REACT_APP_BACKEND_URL}/onboard/twofactor-send-otp`, {
        email: `${formData.personalEmail.email}`,
      }, {
        headers: headers
      })
        .then((response) => {
          setTwoFactorAuthFirstPage(false);
          setTwoFactorAuthSecondPage(true);
          // console.log("OTP sent successfully");
          setMinutes(0);
          setSeconds(60);
        })
        .catch((error) => {
          // Handle error, such as displaying an error message to the user
          console.error("Failed to send OTP:", error);
        });
    } else {
      axios.post(`${process.env.REACT_APP_BACKEND_URL}/onboard/twofactorsend-mobile-otp`, {
        mobileNumber: `${formData.phoneNo}`,
      }, {
        headers: headers
      })
        .then(() => {
          setTwoFactorAuthFirstPage(false);
          setTwoFactorAuthSecondPage(true);
          // console.log("Mobile OTP sent successfully");
          setMinutes(0);
          setSeconds(60);
        })
        .catch((error) => {
          console.error("Failed to send mobile OTP:", error);
        });
    }
  };

  //Timer and otp part

  const [isVerificationFailedDialogOpen, setIsVerificationFailedDialogOpen] =
    useState(false);

  const handleCloseVerificationFailedDialog = () => {
    setValidNext2FA(false);
    setValidVerify2FA(false);
    setCode('');

    setShowCodeError(false);
    setShowErrorMessage(false);

    setSelectedOption(null)
    setIsVerificationFailedDialogOpen(false);
    setTwoFactorAuthFirstPage(true)
    setTwoFactorAuthSecondPage(false);
  };

  const [minutes, setMinutes] = useState(1);
  const [seconds, setSeconds] = useState(0);

  const resendOTP = async () => {
    setMinutes(0);
    setSeconds(60);
    setIsVisible(true);
    try {
      if (selectedOption === "email") {
        if (formData.personalEmail.email.trim() !== "") {
          await axios.post(`${process.env.REACT_APP_BACKEND_URL}/onboard/twofactor-send-otp`, {
            email: formData.personalEmail.email,
          },
            {
              headers: headers
            });
          // console.log("Email OTP resent successfully");
        } else {
          // Handle case where email is not provided
        }
      } else if (selectedOption === "sms") {
        if (formData.phoneNo.trim() !== "") {
          await axios.post(`${process.env.REACT_APP_BACKEND_URL}/onboard/twofactorsend-mobile-otp`,
            {
              mobileNumber: formData.phoneNo,
            },
            {
              headers: headers
            }
          );
          // console.log("Mobile OTP resent successfully");
        } else {
          // Handle case where phone number is not provided
        }
      }
    } catch (error) {
      console.error("Error resending OTP:", error);
      // Handle error, such as displaying an error message to the user
    }
  };

  useEffect(() => {
    if (setTwoFactorAuthSecondPage) {
      const interval = setInterval(() => {
        if (minutes === 0 && seconds === 0) {
          clearInterval(interval);
          // Handle case when timer reaches 0
        } else {
          if (seconds > 0) {
            setSeconds(seconds - 1);
          } else {
            if (minutes > 0) {
              setMinutes(minutes - 1);
              setSeconds(59);
            }
          }
        }
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [setTwoFactorAuthSecondPage, seconds, minutes]);
  // Highlight Resend OTP Button CSS class
  const highlightResendButton =
    minutes === 0 && seconds === 0 ? "highlight" : "";

  // Determine if the Remaining Time should blink
  const shouldBlink = seconds < 20 && minutes === 0 && seconds !== 0;
  const blinkClass = shouldBlink ? "otp-blinking" : "";

  // Format the time with leading zero if necessary
  const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
  const formattedSeconds = seconds < 10 ? `0${seconds}` : seconds;

  const PasswordMenuProps = {
    PaperProps: {
      style: {
        marginTop: "-15px",
      }
    }
  }

  return (
    <>
      {loading && <p>Loading...</p>}
      {!CreatepasswordPage ? (
        <div>
          <h2 className="onboard-slide-title-3">Create Password</h2>
          {/* <p className="paragraph-text">Secure your neoin Id</p> */}

          <div className='popup'>
            <Typography
              aria-owns={open ? 'mouse-over-popover' : undefined}
              aria-haspopup="true"
              onMouseEnter={handlePopoverOpen}
              onMouseLeave={handlePopoverClose}
            >
              <p>Secure your neoin Id <IconButton className="info-icon"> <InfoIcon /></IconButton></p>
            </Typography>
            <Popover
              id="mouse-over-popover"
              sx={{
                pointerEvents: 'none',
              }}
              open={open}
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'bottom'
              }}
              // transformOrigin={{
              //   vertical: 'top',
              //   horizontal: 'bottom',
              // }}
              onClose={handlePopoverClose}
              disableRestoreFocus
              slotProps={{ paper: PasswordMenuProps.PaperProps }}
            >
              <Typography className='pop-content' MenuProps={PasswordMenuProps}>
                <div className="pop-content-item"> <span>&#10003;</span>  At least 8 characters</div>
                <div className="pop-content-item"> <span>&#10003;</span>  At least one small letter</div>
                <div className="pop-content-item"> <span>&#10003;</span>  At least one capital letter</div>
                <div className="pop-content-item"> <span>&#10003;</span>  At least one number or symbol </div>
              </Typography>
            </Popover>
          </div>

          <div className="text-field-container">
            {/* Password input */}
            <TextField
              label="Password"
              type={showPassword ? "text" : "password"} // Toggle password visibility based on showPassword state
              value={password}
              error={
                ShowPasswordError ||
                (password !== confirmPassword && confirmPassword.trim() !== "")
              }
              variant="outlined"
              onChange={handlePasswordChange}
              InputLabelProps={{
                shrink: true,
              }}
              className={`text-field-outline input-text mb-2`}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={togglePasswordVisibility}>
                      {showPassword ? (
                        <VisibilityOffIcon />
                      ) : (
                        <VisibilityIcon />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </div>
          <div className="text-field-container">
            {/* Confirm Password input */}
            <TextField
              label="Confirm Password"
              type={showConfirmPassword ? "text" : "password"} // Toggle password visibility based on showConfirmPassword state
              error={
                ShowPasswordError ||
                (password !== confirmPassword && confirmPassword.trim() !== "")
              }
              variant="outlined"
              value={confirmPassword}
              onChange={handleConfirmPasswordChange}
              InputLabelProps={{
                shrink: true,
              }}
              className={`text-field-outline input-text mb-2`}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={toggleConfirmPasswordVisibility}>
                      {showConfirmPassword ? (
                        <VisibilityOffIcon />
                      ) : (
                        <VisibilityIcon />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </div>

          {ShowPasswordError ? (
            <div className="error-message">
              {(!passwordRegex.test(password) || !passwordRegex.test(confirmPassword))
                ? "Password must contain at least one uppercase, lowercase, and digit each and be at least 8 characters long."
                : (password !== confirmPassword) ? "Entered Passwords do not match."
                  : "Invalid Password"}
            </div>
          ) : <div className="error-message">{" "}</div>}

          <div className="next-button-container password-buttons">
            <span onClick={handlePasswordGen} className="random-password-generator">Generate Random Password?</span>
            <Button
              variant="outlined"
              className={`next-btn primary-outlined`}
              onClick={handleVerifyPassword}
              disabled={isButtonDisabled}>
              Create Account
            </Button>
          </div>
        </div>
      ) : (
        <div>
          {passwordVerified && (
            <Dialog
              open={isVerifiedDialogOpen}
              onClose={handleCloseVerifiedDialog}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogContent className="dialogContainer">
                <img
                  src={AccountCreated}
                  alt="Verification"
                  className="dialogImage"
                />
                <DialogTitle id="alert-dialog-title">
                  Your Neoin Account Created
                </DialogTitle>
                <DialogContentText className="dialogText">
                  Welcome aboard! We're thrilled to have you join Neoin
                </DialogContentText>
                <Button
                  onClick={handleCreatepassword}
                  variant="contained"
                  className="continueButton primary-button"
                >
                  Continue
                </Button>
              </DialogContent>
            </Dialog>
          )}
        </div>
      )}

      {TwoFactorAuthFirstPage &&
        <>
          <h2 className="onboard-2fa-title">Enable 2FA (Two-factor Authentication)</h2>
          <p className="paragraph-text">Choose the Method </p>
          <div className='twofa-choose-method-container'>
            <Sheet
              variant="outlined"
              sx={{
                boxShadow: 'sm',
                borderRadius: 'sm',
                marginBottom: 2,
                p: 1,
                width: 386,
                boxSizing: "border-box",
                border: selectedOption === 'email' ? '1px solid #0044C6' : '1px solid #00000052'
              }}
            >
              <RadioGroup name="tiers" value={selectedOption} onChange={handleOptionChange} sx={{ gap: 1, '& > div': { p: 1 } }}>
                <FormControl>
                  <Radio className='twoFa-radio text-align-left' overlay value="email" label="Email" />
                  <FormHelperText>Receive verification code via Email.</FormHelperText>
                </FormControl>
              </RadioGroup>
            </Sheet>

            <Sheet
              variant="outlined"
              sx={{
                boxShadow: 'sm',
                borderRadius: 'sm',
                p: 1,
                width: 386,
                boxSizing: "border-box",
                border: selectedOption === 'sms' ? '1px solid #0044C6' : '1px solid #00000052'
              }}>
              <RadioGroup name="tiers" value={selectedOption} onChange={handleOptionChange} sx={{ gap: 1, '& > div': { p: 1 } }}>
                <FormControl>
                  <Radio className='twoFa-radio text-align-left' overlay value="sms" label="Mobile SMS" />
                  <FormHelperText>Receive verification code via Mobile.</FormHelperText>
                </FormControl>
              </RadioGroup>
            </Sheet>
          </div>
          <div className="justify-content-flex-end">
            <div className="next-button-container">
              <a href="/cards" className="Link-white-text">
                <button className="skip-btn">
                  SKIP
                </button>
              </a>
              <button
                className={`next-btn ${selectedOption === null || ValidNext2FA ? "disabled" : ""}`}
                type="submit"
                onClick={handleAuthNextPage}
                disabled={selectedOption === null || ValidNext2FA}
              >
                Next
              </button>
            </div>
          </div>

          {isVisible && (
            <InfoToast destination="progress" />
          )}
        </>
      }

      {TwoFactorAuthSecondPage &&
        <div>
          <div className="page-title-wrapper">
            <h2 className="onboard-2fa-title page-title">Enable 2FA (Two-factor Authentication)</h2>
            <p className="paragraph-text page-subtitle">Enter the Code </p>
          </div>
          <div className='twofa-choose-method-container'>
            <TextField
              type={showCode ? "text" : "password"}
              value={code}
              onChange={handleCodeChange}
              onFocus={() => setIsTextFieldSelected(true)}
              onBlur={() => setIsTextFieldSelected(false)}
              error={showCodeError || (showErrorMessage && !isCorrectOTP)}
              helperText={
                showCodeError
                  ? "Code is required"
                  : showErrorMessage && !isCorrectOTP
                    ? "Incorrect OTP. Please try again."
                    : ""
              }
              InputLabelProps={{
                shrink: true,
              }}
              className={`text-field-outline input-text ${(showCodeError || (showErrorMessage && !isCorrectOTP)) &&
                "error-textfield"
                } ${isCorrectOTP ? "correct-textfield" : ""} ${!isTextFieldSelected &&
                !showCodeError &&
                !showErrorMessage &&
                "normal-textfield"
                }`}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={toggleCodeVisibility}>
                      {showCode ? <VisibilityIcon /> : <VisibilityOffIcon />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />


          </div>
          <div className="justify-content-space-bw-login-margins">
            <div className="resent-otp">
              Remaining Time: {" "}
              <span className={`time-unit ${blinkClass}`}>{formattedMinutes}</span>:
              <span className={`time-unit ${blinkClass}`}>{formattedSeconds}</span>
            </div>
            <div className="next-button-container" style={{ gap: "16px" }}>
              <button
                className={`next-btn ${code.trim() === "" || ValidVerify2FA ? "disabled" : ""} `}
                type="submit"
                onClick={handleCodeSubmit}
                disabled={code.trim() === "" || ValidVerify2FA}
              >
                Verify
              </button>
            </div>
          </div>
          <div className={`resent-otp-design-margins ${highlightResendButton}`}>
            Didn't get the OTP? <button onClick={resendOTP}>RESEND</button>
          </div>


          <Dialog
            open={isVerifiedDialogOpen}
            // onClose={handleCloseVerifiedDialog}
            onClick={handleCloseVerifiedDialog}
            aria-labelledby="Enable 2FA (Two-factor Authentication)"
            aria-describedby="alert-dialog-description">
            <DialogContent className="dialog-Container">
              <DialogContentText className="dialogText">
                <div className='justify-content-center-1'>
                  <img
                    src={Tick}
                    alt="Verification"
                    className="dialog-Image"
                  />
                  <p className='mt-10 dialog-content'>
                    Your Two-factor Authentication
                    is Successful</p>
                </div>
              </DialogContentText>
              <a href="/cards" className="Link-white-text">
                <Button
                  onClick={handleContinue2}
                  variant="contained"
                  className="twofa-continueButton primary-button"
                >
                  Continue
                </Button>
              </a>
            </DialogContent>
          </Dialog>
          <Dialog
            open={isVerificationFailedDialogOpen}
            onClose={handleCloseVerificationFailedDialog}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogContent className="dialog-Container">
              <img
                src={Warningimage}
                alt="Verification"
                className="dialog-Image"
              />
              <p className="mt-10 dialog-content">
                Your OTP verification failed. Please try again or resend the
                OTP.
              </p>
              <button
                onClick={handleCloseVerificationFailedDialog}
                variant="contained"
                className="mt-2 next-btn"
              >
                Retry
              </button>
            </DialogContent>
          </Dialog>

        </div>
      }

    </>
  );
};

export default ActiveStep5;
// npm install @mui/joy
